module.exports = __webpack_public_path__ + "img/dislike.4fa83553.svg";